import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import AdminAuthShell, { AuthField, AuthSubmit } from "@/components/AdminAuthShell";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminPasswordForgot() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/admin/password-reset/request`, { email });
      // La risposta è volutamente identica sia che l'account esista o no.
      setSent(true);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Errore durante la richiesta.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminAuthShell
      testId="admin-forgot-page"
      title="Password dimenticata"
      intro={
        sent
          ? undefined
          : "Inserisci l'email del tuo account: ti invieremo un link per scegliere una nuova password."
      }
      error={error}
      success={
        sent
          ? "Se l'indirizzo corrisponde a un account, riceverai a breve un'email con il link per reimpostare la password. Il link è valido per un'ora."
          : ""
      }
      footer={
        <Link
          to="/admin/login"
          data-testid="admin-back-to-login"
          className="text-slate-600 hover:text-slate-900 underline underline-offset-4"
        >
          ← Torna all'accesso
        </Link>
      }
    >
      {!sent && (
        <form onSubmit={onSubmit} className="mt-8 space-y-5" data-testid="admin-forgot-form">
          <AuthField
            label="Email"
            type="email"
            autoFocus
            required
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="admin-forgot-email-input"
          />
          <AuthSubmit
            loading={loading}
            loadingLabel="Invio in corso..."
            data-testid="admin-forgot-submit"
          >
            Invia il link
          </AuthSubmit>
        </form>
      )}
    </AdminAuthShell>
  );
}
